<div class="chat-width-a">
    <h2 mat-dialog-title class="md-title chat-cont-a">
        <img src='../../assets/images/logoclaro2.png' style='width:32px;height:32px; vertical-align: middle;'>
        <label class='labTitle chatTitle-b'>T&eacute;rminos y Condiciones</label>
    </h2>
    <mat-dialog-content class="chat-cont-a">
        <div class="chatJAC">
            <div class="popupbg">
                <div class="popupcont f-reg f-black roboto-r">
                    <div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <label class="termsCons">
                                    Términos y Condiciones para cambio de plan
                                    fijo.
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="padTerms" style="line-height:2;">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <ul  style="text-align: justify; padding-bottom: 10px;line-height: 1.5;">
                                  <li>Los planes sugeridos están considerando la velocidad máxima de internet y disponibilidad de mayores velocidades en tu área.</li>
                                  <li>No se permiten Down Grade de planes.</li>
                                  <li>Se Renueva contrato a 12 o 24 meses, según aplique.</li>
                                  <li>Cliente existente no se le hará verificación de crédito.</li>
                                  <li>La promoción estará sujeta a las velocidades disponibles y aceptadas para el cambio de plan.</li>
                                  <li>La cancelación temprana del servicio de internet, conlleva penalidad de $150 y devolución del modem. Si no devuelve el modem 
                                      aplicará penalidad de $100 adicionales o si lo devuelve incompleto apicará cargo de $35 adicionales.</li>
                                  <li>Precios incluidos no incluyen IVU, ni cargos federales del FUSC y PRUSF, los cuales pueden variar del tiempo en tiempo por 
                                      disposición gubernamental.</li>
                             </ul>
                            </div>
                        </div>
                    </div>
                    <div class="basicrow m-top">
                        <div class="logline full"></div>
                    </div>
                    <div class="basicrow text-center m-top">
                        <a class="btns def-i red pull-right vcenter" (click)="this.close();">
                            <span class="tabcell">
                                Cerrar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>